import {
  predictionData,
  getStatus
} from '@/api/oli_api'

// 进销存预测
const state = {
  predictionDatas: [],
  // 小罐多销
  predictionDatasXD: [],
  // 小罐每日订单
  predictionDatasDay: [],
  selectPredictionGas: null,
  predictionGasList: []
}

const getters = {
  predictionDatas: state => state.predictionDatas,
  predictionDatasXD: state => state.predictionDatasXD,
  predictionDatasDay: state => state.predictionDatasDay,
  selectPredictionGas: state => state.selectPredictionGas,
  predictionGasList: state => state.predictionGasList
}

const actions = {
  prediction ({ dispatch }, data) {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '分析预测中')
    dispatch('setPercentage', {'start': 0, 'next': 100})
    predictionData().then((data) => {
      if (data.code === 1) {
        dispatch('getPredictionStatus')
        return
      }
      dispatch('dealPredictionData', data)
      dispatch('setFlowStatus', 30)
      dispatch('setLoadingText', '分析预测完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    })
  },
  dealPredictionData ({ commit, dispatch, getters }, data) {
    let preData = {
      jcxDatas: {},
      dayOrder: [],
      xgdx: []
    }
    data.forEach(function (item) {
      item.sub = (item['有效容积'] - item['平均销量']).toFixed(2)
      item['消耗率'] = (item['平均销量'] / 24).toFixed(2)
      if (typeof preData['jcxDatas'][item['加油站名称']] === 'undefined') {
        preData['jcxDatas'][item['加油站名称']] = []
      }
      preData['jcxDatas'][item['加油站名称']].push(item)
      if (item['订单紧急程度'] !== '库存充足订单' && item['时间'] === getters.todayStr) {
        preData['dayOrder'].push(item)
      }
      if (item['小罐多销'] === 1) {
        preData['xgdx'].push(item)
      }
    })
    let pData = preData['jcxDatas']
    let delPData = []
    let oilStations = []
    for (let key in pData) {
      oilStations.push(key)
      let sData = pData[key].sort((a, b) => {
        return a['代号'] > b['代号']
      })
      delPData.push({'oil': key, data: sData})
    }
    dispatch('setPredictionGasList', oilStations)
    dispatch('setPredictionDatas', delPData)
    dispatch('setPredictionDatasXD', preData['xgdx'])
    dispatch('setPredictionDatasDay', preData['dayOrder'])
  },
  getPredictionStatus ({ dispatch }, data) {
    setTimeout(function () {
      getStatus({key: 'prediction'}).then(function (data) {
        let pStatus = data.data
        if (pStatus === 'doing') {
          dispatch('getPredictionStatus')
        } else if (pStatus === 'idle') {
          dispatch('prediction')
        }
      })
    }, 5000)
  },
  setPredictionDatas ({ commit, dispatch, getters }, data) {
    // 设置预测数据
    let newData = []
    let gasLocation = getters.gasLocation
    data.forEach(function (item) {
      if (gasLocation && gasLocation[item.oil]) {
        newData.push({
          name: item.oil,
          value: [...gasLocation[item.oil]]
        })
      }
    })
    dispatch('setAllMapOil', newData)
    commit('setPredictionDatas', data)
  },
  setPredictionDatasXD ({ commit }, data) {
    commit('setPredictionDatasXD', data)
  },
  setPredictionDatasDay ({ commit }, data) {
    commit('setPredictionDatasDay', data)
  },
  setSelectPredictionGas ({ commit }, data) {
    commit('setSelectPredictionGas', data)
  },
  setPredictionGasList ({ commit, getters, dispatch }, data) {
    commit('setPredictionGasList', data)
    if (!getters.selectPredictionGas && data.length) {
      dispatch('setSelectPredictionGas', data[0])
    }
  }
}

const mutations = {
  setPredictionDatas (state, data) {
    state.predictionDatas = data
  },
  setPredictionDatasXD (state, data) {
    state.predictionDatasXD = data
  },
  setPredictionDatasDay (state, data) {
    state.predictionDatasDay = data
  },
  setSelectPredictionGas (state, data) {
    state.selectPredictionGas = data
  },
  setPredictionGasList (state, data) {
    state.predictionGasList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/prediction.js